export function isOnboarded (state) {
  return state.isOnboarded
}

export function systemNotifications (state) {
  return state.systemNotifications
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/onboarding/getters.js
// module id = null
// module chunks = 